export const FONT_OPTIONS = [
  { id: 'cairo',    name: 'Cairo',            label: 'كايرو',     sample: 'متجر إبداع الطائف', css: "'Cairo', sans-serif" },
  { id: 'tajawal',  name: 'Tajawal',          label: 'تجوال',     sample: 'متجر إبداع الطائف', css: "'Tajawal', sans-serif" },
  { id: 'almarai',  name: 'Almarai',          label: 'المراعي',   sample: 'متجر إبداع الطائف', css: "'Almarai', sans-serif" },
  { id: 'noto-kufi',name: 'Noto Kufi Arabic', label: 'نوتو كوفي', sample: 'متجر إبداع الطائف', css: "'Noto Kufi Arabic', sans-serif" },
  { id: 'readex',   name: 'Readex Pro',       label: 'ريدكس برو', sample: 'متجر إبداع الطائف', css: "'Readex Pro', sans-serif" },
  { id: 'ibm-plex', name: 'IBM Plex Arabic',  label: 'IBM بلكس',  sample: 'متجر إبداع الطائف', css: "'IBM Plex Arabic', sans-serif" },
];

export const RADIUS_OPTIONS = [
  { id: 'none', label: 'مربع',  value: '0px'    },
  { id: 'sm',   label: 'خفيف',  value: '6px'    },
  { id: 'md',   label: 'متوسط', value: '12px'   },
  { id: 'lg',   label: 'دائري', value: '20px'   },
  { id: 'full', label: 'كامل',  value: '9999px' },
];

export const BUTTON_STYLES = [
  { id: 'filled',   label: 'ممتلئ', desc: 'خلفية ملونة' },
  { id: 'outlined', label: 'محدد',  desc: 'حدود فقط'   },
  { id: 'soft',     label: 'ناعم',  desc: 'خلفية فاتحة' },
];

export const LAYOUT_OPTIONS = [
  { id: 'default', label: 'افتراضي', icon: 'ri-layout-3-line',      desc: 'تخطيط متوازن' },
  { id: 'wide',    label: 'عريض',    icon: 'ri-layout-2-line',      desc: 'محتوى أوسع'  },
  { id: 'compact', label: 'مضغوط',   icon: 'ri-layout-column-line', desc: 'مساحة أقل'   },
];

export const HERO_STYLES = [
  { id: 'gradient', label: 'تدرج لوني',  icon: 'ri-contrast-2-line'   },
  { id: 'image',    label: 'صورة خلفية', icon: 'ri-image-line'         },
  { id: 'minimal',  label: 'بسيط',       icon: 'ri-subtract-line'      },
  { id: 'split',    label: 'مقسّم',      icon: 'ri-layout-column-line' },
];

export const CARD_STYLES = [
  { id: 'shadow', label: 'ظل خفيف', icon: 'ri-stack-line'          },
  { id: 'border', label: 'حدود',    icon: 'ri-checkbox-blank-line' },
  { id: 'flat',   label: 'مسطح',    icon: 'ri-stop-line'           },
  { id: 'glass',  label: 'زجاجي',   icon: 'ri-blur-off-line'       },
];

export const NAVBAR_STYLES = [
  { id: 'dark',        label: 'داكن',  desc: 'خلفية سوداء كلاسيكية',    bg: '#0a0a0a',  text: '#fff' },
  { id: 'transparent', label: 'شفاف',  desc: 'يظهر على الخلفية مباشرة', bg: 'transparent', text: '#fff' },
  { id: 'light',       label: 'فاتح',  desc: 'خلفية بيضاء نظيفة',       bg: '#ffffff',  text: '#1a1a1a' },
  { id: 'colored',     label: 'ملون',  desc: 'بلون المتجر الرئيسي',     bg: 'primary',  text: 'auto' },
  { id: 'glass',       label: 'زجاجي', desc: 'تأثير ضبابي شفاف',        bg: 'glass',    text: '#fff' },
];

export const NAVBAR_HEIGHTS = [
  { id: 'sm', label: 'صغير',  value: '56px' },
  { id: 'md', label: 'متوسط', value: '72px' },
  { id: 'lg', label: 'كبير',  value: '88px' },
];

export const FOOTER_STYLES = [
  { id: 'dark',     label: 'داكن جداً',    desc: 'أسود عميق',       bg: '#080808', text: '#6b7280' },
  { id: 'charcoal', label: 'فحمي',          desc: 'رمادي داكن أنيق', bg: '#111827', text: '#6b7280' },
  { id: 'navy',     label: 'كحلي',          desc: 'أزرق داكن راقي',  bg: '#0f172a', text: '#64748b' },
  { id: 'forest',   label: 'غابي',          desc: 'أخضر داكن طبيعي', bg: '#052e16', text: '#4ade80' },
  { id: 'wine',     label: 'خمري',          desc: 'بني داكن دافئ',   bg: '#1c0a00', text: '#92400e' },
  { id: 'slate',    label: 'رمادي أردوازي', desc: 'رمادي متوسط',     bg: '#1e293b', text: '#64748b' },
];

export const FOOTER_LAYOUTS = [
  { id: 'four-col',  label: '4 أعمدة', icon: 'ri-layout-grid-line' },
  { id: 'three-col', label: '3 أعمدة', icon: 'ri-layout-3-line'    },
  { id: 'minimal',   label: 'مبسّط',   icon: 'ri-subtract-line'    },
  { id: 'centered',  label: 'مركزي',   icon: 'ri-align-center'     },
];

export const LOGO_SHAPES = [
  { id: 'circle',   label: 'دائري', radius: '50%'  },
  { id: 'rounded',  label: 'مدوّر', radius: '16px' },
  { id: 'square',   label: 'مربع',  radius: '0px'  },
  { id: 'squircle', label: 'ناعم',  radius: '30%'  },
];

export const LOGO_TEXT_STYLES = [
  { id: 'gradient', label: 'تدرج لوني', desc: 'بألوان المتجر' },
  { id: 'white',    label: 'أبيض',      desc: 'نص أبيض نقي'  },
  { id: 'dark',     label: 'داكن',      desc: 'نص أسود'       },
  { id: 'gold',     label: 'ذهبي',      desc: 'لون ذهبي فاخر' },
];

export const HERO_IMAGE_PRESETS = [
  {
    id: 'tech-dark',
    label: 'تقنية داكنة',
    url: 'https://public.readdy.ai/ai/img_res/f5ed3fd4819babeaed3be35c9020e489.jpg',
  },
  {
    id: 'gaming',
    label: 'ألعاب',
    url: 'https://readdy.ai/api/search-image?query=professional%20gaming%20setup%20with%20RGB%20lights%20controllers%20headset%20on%20dark%20background%20dramatic%20lighting%20cinematic%20wide%20shot&width=1200&height=600&seq=hero-gaming&orientation=landscape',
  },
  {
    id: 'electronics',
    label: 'إلكترونيات',
    url: 'https://readdy.ai/api/search-image?query=premium%20electronics%20products%20smartphones%20laptops%20tablets%20arranged%20beautifully%20on%20dark%20minimal%20background%20professional%20product%20photography&width=1200&height=600&seq=hero-electronics&orientation=landscape',
  },
  {
    id: 'abstract',
    label: 'تجريدي',
    url: 'https://readdy.ai/api/search-image?query=abstract%20dark%20geometric%20shapes%20with%20golden%20amber%20glowing%20particles%20luxury%20premium%20background%20wide%20cinematic&width=1200&height=600&seq=hero-abstract&orientation=landscape',
  },
  {
    id: 'minimal-dark',
    label: 'بسيط داكن',
    url: 'https://readdy.ai/api/search-image?query=minimal%20dark%20black%20background%20with%20subtle%20texture%20and%20soft%20gradient%20light%20luxury%20premium%20store%20background%20wide&width=1200&height=600&seq=hero-minimal-dark&orientation=landscape',
  },
  {
    id: 'city-night',
    label: 'مدينة ليلية',
    url: 'https://readdy.ai/api/search-image?query=city%20night%20lights%20bokeh%20dark%20background%20luxury%20premium%20wide%20cinematic%20shot%20with%20golden%20light%20trails&width=1200&height=600&seq=hero-city-night&orientation=landscape',
  },
];

export const BRAND_ICONS = [
  { id: 'store',     icon: 'ri-store-2-fill',    label: 'متجر'   },
  { id: 'game',      icon: 'ri-gamepad-fill',     label: 'ألعاب'  },
  { id: 'star',      icon: 'ri-star-fill',        label: 'نجمة'   },
  { id: 'crown',     icon: 'ri-vip-crown-fill',   label: 'تاج'    },
  { id: 'diamond',   icon: 'ri-vip-diamond-fill', label: 'ماسة'   },
  { id: 'lightning', icon: 'ri-flashlight-fill',  label: 'برق'    },
  { id: 'shield',    icon: 'ri-shield-fill',      label: 'درع'    },
  { id: 'fire',      icon: 'ri-fire-fill',        label: 'نار'    },
  { id: 'rocket',    icon: 'ri-rocket-fill',      label: 'صاروخ'  },
  { id: 'cpu',       icon: 'ri-cpu-fill',         label: 'معالج'  },
  { id: 'headphone', icon: 'ri-headphone-fill',   label: 'سماعة'  },
  { id: 'phone',     icon: 'ri-smartphone-fill',  label: 'هاتف'   },
];

export const BG_PATTERNS = [
  { id: 'none',  label: 'بدون', desc: 'خلفية نظيفة' },
  { id: 'dots',  label: 'نقاط', desc: 'نقاط خفيفة'  },
  { id: 'grid',  label: 'شبكة', desc: 'خطوط شبكية'  },
  { id: 'lines', label: 'خطوط', desc: 'خطوط قطرية'  },
  { id: 'noise', label: 'ضجيج', desc: 'نسيج ناعم'   },
];

export const PAGE_BG_PRESETS = [
  { id: 'black',       label: 'أسود',          color: '#0a0a0a',  textColor: '#ffffff', preview: 'bg-[#0a0a0a]' },
  { id: 'dark-gray',   label: 'رمادي داكن',    color: '#111827',  textColor: '#ffffff', preview: 'bg-[#111827]' },
  { id: 'charcoal',    label: 'فحمي',           color: '#1c1c1e',  textColor: '#ffffff', preview: 'bg-[#1c1c1e]' },
  { id: 'deep-navy',   label: 'كحلي عميق',     color: '#0d1117',  textColor: '#ffffff', preview: 'bg-[#0d1117]' },
  { id: 'dark-green',  label: 'أخضر داكن',     color: '#0a1a0f',  textColor: '#ffffff', preview: 'bg-[#0a1a0f]' },
  { id: 'dark-wine',   label: 'خمري داكن',     color: '#1a0a0a',  textColor: '#ffffff', preview: 'bg-[#1a0a0a]' },
  { id: 'dark-purple', label: 'بنفسجي داكن',   color: '#0f0a1a',  textColor: '#ffffff', preview: 'bg-[#0f0a1a]' },
  { id: 'off-white',   label: 'أبيض مائل',     color: '#f8f7f4',  textColor: '#1a1a1a', preview: 'bg-[#f8f7f4]' },
  { id: 'warm-white',  label: 'أبيض دافئ',     color: '#faf8f5',  textColor: '#1a1a1a', preview: 'bg-[#faf8f5]' },
  { id: 'light-gray',  label: 'رمادي فاتح',    color: '#f3f4f6',  textColor: '#1a1a1a', preview: 'bg-[#f3f4f6]' },
  { id: 'cream',       label: 'كريمي',          color: '#fdf6ec',  textColor: '#1a1a1a', preview: 'bg-[#fdf6ec]' },
  { id: 'custom',      label: 'مخصص',           color: '',         textColor: '#ffffff', preview: '' },
];

export const GRADIENT_PRESETS = [
  { name: 'ذهبي فاخر', from: '#fbbf24', to: '#f59e0b', text: '#000' },
  { name: 'غروب',       from: '#f97316', to: '#ef4444', text: '#fff' },
  { name: 'أخضر طبيعي', from: '#10b981', to: '#059669', text: '#fff' },
  { name: 'وردي ناعم',  from: '#f43f5e', to: '#ec4899', text: '#fff' },
  { name: 'فيروزي',     from: '#2dd4bf', to: '#0d9488', text: '#000' },
  { name: 'رمادي أنيق', from: '#6b7280', to: '#374151', text: '#fff' },
  { name: 'ذهبي وردي',  from: '#fbbf24', to: '#f43f5e', text: '#fff' },
  { name: 'ليلي',       from: '#6366f1', to: '#8b5cf6', text: '#fff' },
  { name: 'سماء صافية', from: '#38bdf8', to: '#0ea5e9', text: '#000' },
];
